module.exports = __webpack_public_path__ + "static/media/Triangle.aeee504e.svg";